<template>
  <div class="col-12" style="padding: 0px">
    <div class="card">
        <div class="card-header">
          <h4>
            {{ table.title }}
          </h4>
          <div>
            <button class="btn btn-warning btn-sm" style="border-radius: 0px; background: #F0A04B !important; border: none" @click="print()">
              <i class="fa fa-print"></i>
              طباعة الجدول
            </button>
            <button class="btn btn-primary btn-sm" style="border-radius: 0px; border: none" v-b-modal.shuffle>
              <i class="fa fa-random"></i>
              توزيع تلقائي الآن
            </button>
          </div>
        </div>
        <b-modal id="shuffle" title="توزيع الآن" hide-footer>
            <div class="shadow card card-body border" style="margin: 10px">
                <span><i class="fa fa-check-square"></i> اختيار المعلمين</span>
                <div class="form-check" v-for="t in teachers" :key="t._id">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="shuffle.teachers" :value="t._id">
                    {{ t.name }}
                  </label>
                </div>
            </div>
            <div class="shadow card card-body border" style="margin: 10px">
                <span><i class="fa fa-check-square"></i> اختيار الفصول</span>
                <div class="form-check" v-for="t in classrooms" :key="t._id">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="shuffle.classrooms" :value="t._id">
                    {{ t.title }}
                  </label>
                </div>
            </div>
            <div class="shadow card card-body border" style="margin: 10px">
                <span><i class="fa fa-check-square"></i> اختيار المواد</span>
                <div class="form-check" v-for="t in subjects" :key="t._id">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="shuffle.subjects" :value="t._id">
                    {{ t.title }}
                  </label>
                </div>
            </div>
            <div class="col-12 text-center g">
              <button class="btn btn-primary" style="border-radius: 0px" @click="shuffleNow()" v-if="!shuffle.loading">
                <i class="fa fa-check"></i>
                توزيع الآن
              </button>
              <button class="btn btn-lg text-primary" style="border-radius: 0px" disabled v-if="shuffle.loading">
                <img :src="require('@/assets/images/loading.svg')" width="32">
                جاري التوزيع...
              </button>
              <span v-if="shuffle.loading" class="text-muted">
                <br>
                ربما يستغرق دقائق...
              </span>
            </div>
        </b-modal>
        <div class="card-body text-center" v-if="loading">
          <img :src="require('@/assets/images/loading.svg')" width="60">
          جاري التحميل...
        </div>
        <div class="card-body" v-if="table.time && !loading">
          <div class="col-12 g" v-if="logs.length">
            <div class="alert alert-warning g border shadow" style="border: 2px solid #777 !important">
              <h5 class="text-danger"><i class="fa fa-warning"></i> ملاحظات التوزيع</h5>
              <ol>
                <li class="text-dark" v-for="ix in logs" :key="ix" v-html="ix"></li>
              </ol>
              <div class="col-12">
                <a href="javascript:;" @click="logs = []"><i class="fa fa-times"></i> اخفاء التنبيه</a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6 col-lg-2 g" v-for="c in classrooms" :key="c._id">
              <div class=" g adsd" :style="`border-radius: 5px; background: #F4F8D3; border: 2px solid #999; ` + (selected_classroom == c._id ? 'border: 2px solid green; background: #D1F8EF' : '')" @click="viewClassroom(c._id)">
                <strong>{{ c.classname + ' ~ ' + c.title }}</strong>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6 c g" v-if="noSelect">
            <div class="alert alert-warning text-center g">
              اختر الفصل
            </div>
          </div>
          <div class="col-12 g" v-if="!noSelect && items.length == 0">
            <div class="alert alert-danger text-center g">
              لا يوجد جدول لهذا الفصل
            </div>
          </div>
            <div class="col-12 table-responsive" id="table" v-if="!noSelect">
              <h4 class="dnone">جدول فصل {{ className(selected_classroom) }}</h4>
              <table class="table-bordered table table-sm table-hover table-striped">
                <thead>
                  <th>
                    <span style="float: left">الحصة</span>
                    <br>
                    <span style="border-top: 1px solid #ddd; width: 100% !important; float: right">اليوم</span>
                  </th>
                  <th v-for="(a,b) in Array(table.time.max_lessons).fill(0)" :key="b">
                    <strong>الحصة
                    {{ b+1 }}</strong>
                    <br>
                    <small class="text-muted">
                      {{ table.time.lessons_times[b+1][0] }} &mdash; {{ table.time.lessons_times[b+1][1] }}
                    </small>
                  </th>
                </thead>
                <tbody>
                  <tr v-for='day in table.time.days' :key="day">
                    <td>
                      <strong>{{ day
                      .replace("Sunday", "الاحد")
                      .replace("Monday", "الاثنين")
                      .replace("Tuesday", "الثلاثاء")
                      .replace("Wednesday", "الاربعاء")
                      .replace("Thursday", "الخميس")
                      .replace("Saturday", "السبت")
                      .replace("Friday", "الجمعة")
                       }}</strong>
                    </td>
                    <td v-for="(a,b) in Array(table.time.max_lessons).fill(0)" :key="b" :class="!table.time.days_lessons[day][b+1] ? 'bg-light-secondary text-center' : ''">
                      <small class="text-muted" v-if="!table.time.days_lessons[day][b+1]">
                        <i>غير مفعلة</i>
                      </small>
                      <template v-if="!edits[day+b]">
                        <small v-if="table.time.days_lessons[day][b+1]">
                          <a href="javascript:;" @click="edits = {};edits[day+b] = true; currentItem = getItem(day, b+1).teacher_id + ',' + getItem(day, b+1).subject_id; refresh()">
                            <i class="fa fa-edit"></i>
                          </a>&nbsp;
                          <strong>{{ subjectName(getItem(day, b+1).subject_id) }}</strong>
                          <br>
                          {{ teacherName(getItem(day, b+1).teacher_id) }}
                        </small>
                      </template>
                      <template v-if="edits[day+b]">
                        <select class="form-control form-control-sm" v-model="currentItem" @change="editItem(day, b+1)">
                          <option value="undefined,undefined">-- اختر --</option>
                         <option v-for="y in classroomTeachers(getItem(day, b+1).classroom_id)" :key="y._id" :value="y._id">
                          {{ y.title }}
                         </option>
                        </select>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="form-check">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input" v-model="checks">
                  التأكد من عدم التعارضات او تجاوز النصاب عند التعديل اليدوي.
                </label>
              </div>
            </div>
        </div>
    </div>
    <div class="card card-body">
      <h5>
        <i class="fa fa-random"></i>
        ما تم توزيعه
      </h5>
      <div class="row">
        <div class="col-12 col-lg-6 g table-responsive" style="min-height: 0px !important">
          <table class="table table-hover table-sm table-bordered">
            <thead>
              <th>
                المعلم
              </th>
              <th>
                النصاب
              </th>
              <th>
                ما تم توزيعه
              </th>
              <th>
                العدد الاقصى للحصص
              </th>
              <th>
                التفاصيل
              </th>
            </thead>
            <tbody>
            <b-modal id="tdetails" title="التفاصيل" hide-footer>
              <table class="table table-hover table-sm table-bordered">
                <thead>
                  <th>
                    الفصل
                  </th>
                  <th>
                    المادة
                  </th>
                  <th>
                    اليوم
                  </th>
                  <th>
                    الحصة
                  </th>
                </thead>
                <tbody v-for="item in teacherDetails" :key="item._id">
                  <td>
                    {{ className(item.classroom_id) }} 
                  </td>
                  <td>
                    {{ subjectName(item.subject_id) }} 
                  </td>
                  <td>
                    {{ item.day.replace('Sunday', "الاحد")
                    .replace('Monday', "الاثنين")
                    .replace('Tuesday', "الثلاثاء")
                    .replace('Wednesday', "الاربعاء")
                    .replace('Thursday', "الخميس")
                    .replace('Firday', "الجمعة")
                    .replace('Saturday', "السبت") }} 
                  </td>
                  <td>
                    {{ item.lesson }} 
                  </td>
                </tbody>
              </table>
            </b-modal>
              <tr v-for="t in teachers" :key="t._id" :class="t.items_length < t.subjects_items ? 'bg-light-primaryx' : (t.items_length > t.subjects_items ? 'bg-light-danger' : 'bg-light-success')">
                <td>
                  {{ t.name }}
                </td>
                <td>
                  {{ t.subjects_items }}
                </td>
                <td>
                  {{ t.items_length }}
                </td>
                <td>
                  {{ t.config.max_lessons }}
                </td>
                <td>
                  <button v-b-modal.tdetails class="btn btn-sm text-primary" @click="teacherDetails = originalItems.filter(function(x){
                    if(x.teacher_id == t._id){
                      return x;
                    }else{
                      return false;
                    }
                  })">
                    <i class="fa fa-list"></i>
                    التفاصيل
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

            <b-modal id="sdetails" title="التفاصيل" hide-footer>
              <table class="table table-hover table-sm table-bordered">
                <thead>
                  <th>
                    الفصل
                  </th>
                  <th>
                    ما تم توزيعه
                  </th>
                  <th>
                    العدد الاقصى للحصص
                  </th>
                </thead>
                <tbody v-for="item in teacherDetails2" :key="item._id">
                  <td>
                    {{ item.title }}
                  </td>
                  <td>
                    {{ item.done }}
                  </td>
                  <td>
                    {{ item.lessons }}
                  </td>
                </tbody>
              </table>
            </b-modal>
        <div class="col-12 col-lg-6 g table-responsive"  style="min-height: 0px !important">
          <table class="table table-hover table-sm table-bordered">
            <thead>
              <th>
                المادة
              </th>
              <th>
                ما تم توزيعه
              </th>
              <th>
                العدد الاقصى للحصص
              </th>
              <th>
                التفاصيل
              </th>
            </thead>
            <tbody>
              <tr v-for="t in subjects" :key="t._id" :class="t.items_length < t.total_items ? 'bg-light-primaryx' : (t.items_length > t.total_items ? 'bg-light-danger' : 'bg-light-success')">
                <td>
                  {{ t.title }}
                </td>
                <td>
                  {{ t.items_length }}
                </td>
                <td>
                  {{ t.total_items }}
                </td>

                <td>
                  <button v-b-modal.sdetails class="btn btn-sm text-primary" @click="getSubjectDetails(t)">
                    <i class="fa fa-list"></i>
                    التفاصيل
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
function makeid(length) {
    let result = '';
    const characters = 'abcdefghkmnoprstuvwxyz123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

function countSubjectInDay(classroomSchedule, classroomId, day, subjectId) {
  var count = 0;
  var schedule = classroomSchedule[classroomId][day];
  for (var key in schedule) {
    if (schedule[key] && schedule[key].subject_id === subjectId) {
      count++;
    }
  }
  return count;
}

function tryPlaceSchedule(requirements, tableId, days, maxLessonsPerDay, data, subjectsMap, teachersMap, checkSlotEnabled) {
  var teacherSchedule = {};
  var teacherLessonCount = {};
  data.teachers.forEach(function(t) {
    teacherSchedule[t._id] = {};
    teacherLessonCount[t._id] = 0;
    days.forEach(function(d) { teacherSchedule[t._id][d] = {}; });
  });

  var classroomSchedule = {};
  data.classrooms.forEach(function(c) {
    classroomSchedule[c._id] = {};
    days.forEach(function(d) { classroomSchedule[c._id][d] = {}; });
  });

  var reqs = requirements.slice();
  shuffleArray(reqs);
  reqs.sort(function(a, b) {
    if (a.type === 'double' && b.type !== 'double') return -1;
    if (a.type !== 'double' && b.type === 'double') return 1;
    if (a.is_first && !b.is_first) return -1;
    if (!a.is_first && b.is_first) return 1;
    return 0;
  });

  var timetable = [];
  var logs = [];
  var unplacedCount = 0;

  for (var r = 0; r < reqs.length; r++) {
    var req = reqs[r];
    var placed = false;

    var teachers = (data.subjectsofteacher[req.subject_id] || []).filter(function(tid) {
      var teacher = teachersMap[tid];
      return teacher && teacher.assigns.indexOf(req.classroom_id + ',' + req.subject_id) !== -1;
    });
    shuffleArray(teachers);

    if (teachers.length === 0) {
      logs.push('لا يوجد معلم مسند لمادة <b>' + (data.names[req.subject_id] || '') + '</b> في الفصل <b>' + (data.names[req.classroom_id] || '') + '</b>');
      unplacedCount++;
      continue;
    }

    var sortedDays = days.slice();
    shuffleArray(sortedDays);
    sortedDays.sort(function(a, b) {
      var aCount = countSubjectInDay(classroomSchedule, req.classroom_id, a, req.subject_id);
      var bCount = countSubjectInDay(classroomSchedule, req.classroom_id, b, req.subject_id);
      if (aCount !== bCount) return aCount - bCount;
      var aTotalCount = Object.keys(classroomSchedule[req.classroom_id][a]).length;
      var bTotalCount = Object.keys(classroomSchedule[req.classroom_id][b]).length;
      return aTotalCount - bTotalCount;
    });

    if (req.type === 'double') {
      var startPositions = [];
      for (var s = 1; s < maxLessonsPerDay; s++) startPositions.push(s);
      if (!req.is_first) shuffleArray(startPositions);

      for (var di = 0; di < sortedDays.length && !placed; di++) {
        var day = sortedDays[di];
        if (countSubjectInDay(classroomSchedule, req.classroom_id, day, req.subject_id) > 0) continue;

        for (var si = 0; si < startPositions.length && !placed; si++) {
          var lesson1 = startPositions[si];
          var lesson2 = lesson1 + 1;
          if (!checkSlotEnabled(day, lesson1) || !checkSlotEnabled(day, lesson2)) continue;
          if (classroomSchedule[req.classroom_id][day][lesson1] || classroomSchedule[req.classroom_id][day][lesson2]) continue;

          for (var ti = 0; ti < teachers.length && !placed; ti++) {
            var teacherId = teachers[ti];
            var teacher = teachersMap[teacherId];
            var maxL = parseInt(teacher.config && teacher.config.max_lessons) || 24;

            if (teacherLessonCount[teacherId] + 2 > maxL) continue;
            if (teacherSchedule[teacherId][day][lesson1] || teacherSchedule[teacherId][day][lesson2]) continue;

            var item1 = { classroom_id: req.classroom_id, table_id: tableId, lesson: lesson1, day: day, subject_id: req.subject_id, teacher_id: teacherId };
            var item2 = { classroom_id: req.classroom_id, table_id: tableId, lesson: lesson2, day: day, subject_id: req.subject_id, teacher_id: teacherId };

            timetable.push(item1, item2);
            classroomSchedule[req.classroom_id][day][lesson1] = item1;
            classroomSchedule[req.classroom_id][day][lesson2] = item2;
            teacherSchedule[teacherId][day][lesson1] = true;
            teacherSchedule[teacherId][day][lesson2] = true;
            teacherLessonCount[teacherId] += 2;
            placed = true;
          }
        }
      }
    } else {
      var lessonOrder = [];
      for (var l = 1; l <= maxLessonsPerDay; l++) lessonOrder.push(l);
      if (!req.is_first) shuffleArray(lessonOrder);

      for (var di2 = 0; di2 < sortedDays.length && !placed; di2++) {
        var day2 = sortedDays[di2];
        if (countSubjectInDay(classroomSchedule, req.classroom_id, day2, req.subject_id) > 0) continue;

        for (var li = 0; li < lessonOrder.length && !placed; li++) {
          var lesson = lessonOrder[li];
          if (!checkSlotEnabled(day2, lesson)) continue;
          if (classroomSchedule[req.classroom_id][day2][lesson]) continue;

          for (var ti2 = 0; ti2 < teachers.length && !placed; ti2++) {
            var teacherId2 = teachers[ti2];
            var teacher2 = teachersMap[teacherId2];
            var maxL2 = parseInt(teacher2.config && teacher2.config.max_lessons) || 24;

            if (teacherLessonCount[teacherId2] >= maxL2) continue;
            if (teacherSchedule[teacherId2][day2][lesson]) continue;

            var item = { classroom_id: req.classroom_id, table_id: tableId, lesson: lesson, day: day2, subject_id: req.subject_id, teacher_id: teacherId2 };

            timetable.push(item);
            classroomSchedule[req.classroom_id][day2][lesson] = item;
            teacherSchedule[teacherId2][day2][lesson] = true;
            teacherLessonCount[teacherId2]++;
            placed = true;
          }
        }
      }
    }

    if (!placed) {
      logs.push('لم يتم توزيع مادة <b>' + (data.names[req.subject_id] || '') + '</b> في الفصل <b>' + (data.names[req.classroom_id] || '') + '</b> (' + (req.type === 'double' ? 'حصة مزدوجة' : 'حصة فردية') + ')');
      unplacedCount++;
    }
  }

  return { timetable: timetable, logs: logs, unplacedCount: unplacedCount };
}

function generateSchoolTimetable(data) {
  var tableId = data.table._id;
  var days = data.time.days;
  var maxLessonsPerDay = parseInt(data.time.max_lessons) || 7;
  var daysLessons = data.time.days_lessons || {};

  var subjectsMap = {};
  data.subjects.forEach(function(s) { subjectsMap[s._id] = s; });

  var teachersMap = {};
  data.teachers.forEach(function(t) { teachersMap[t._id] = t; });

  function checkSlotEnabled(day, lesson) {
    return daysLessons[day] && daysLessons[day][lesson];
  }

  var requirements = [];

  data.classrooms.forEach(function(classroom) {
    (classroom.subjects || []).forEach(function(subjectId) {
      var subject = subjectsMap[subjectId];
      if (!subject) return;

      var singleCount = parseInt(subject.single_lessons) || 0;
      var doubleCount = parseInt(subject.double_lessons) || 0;

      if (subject.customClassesLessonsSingle && subject.customClassesLessonsSingle[classroom._id] != null && String(subject.customClassesLessonsSingle[classroom._id]) !== '') {
        singleCount = parseInt(subject.customClassesLessonsSingle[classroom._id]) || 0;
      }
      if (subject.customClassesLessonsDouble && subject.customClassesLessonsDouble[classroom._id] != null && String(subject.customClassesLessonsDouble[classroom._id]) !== '') {
        doubleCount = parseInt(subject.customClassesLessonsDouble[classroom._id]) || 0;
      }

      for (var i = 0; i < doubleCount; i++) {
        requirements.push({
          classroom_id: classroom._id,
          subject_id: subjectId,
          type: 'double',
          is_first: subject.is_first || false
        });
      }

      for (var j = 0; j < singleCount; j++) {
        requirements.push({
          classroom_id: classroom._id,
          subject_id: subjectId,
          type: 'single',
          is_first: subject.is_first || false
        });
      }
    });
  });

  var bestResult = { timetable: [], logs: [], unplacedCount: requirements.length + 1 };
  var numAttempts = Math.min(20, Math.max(5, Math.ceil(requirements.length / 10)));

  for (var attempt = 0; attempt < numAttempts; attempt++) {
    var result = tryPlaceSchedule(requirements, tableId, days, maxLessonsPerDay, data, subjectsMap, teachersMap, checkSlotEnabled);
    if (result.unplacedCount < bestResult.unplacedCount) {
      bestResult = result;
    }
    if (bestResult.unplacedCount === 0) break;
  }

  return bestResult;
}

import { VBModal, BModal, BFormInput, BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
    components: {
        // Layouts
        BDropdown, BDropdownItem,
        BModal,BFormInput},
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
  data(){
    return {
      id: window.location.href.split("table/")[1],
      user: JSON.parse(localStorage.getItem("user")),
      edits: {},
      table: {},
      teacherDetails: [],
      teacherDetails2: [],
      currentItem: "",
      selectForEdit: "",
      teachers: [],
      subjects: [],
      classrooms: [],
      teachersObj: {},
      subjectsObj: {},
      classroomsObj: {},
      noSelect: true,
      selected_classroom: "",
      items: [],
      checks: true,
      originalItems: [],
      shuffle: {
        teachers: [],
        subjects: [],
        classrooms: [],
        loading: false
      },
      loading: true,
      logs: []
    }
  },
  methods: {
    getSubjectDetails(subject){
      var g = this;
      var arr = [];
      subject.classrooms.forEach(function(a){
        var x = {
          title: g.className(a),
          lessons: 
          (subject.customClassesLessonsSingle[a] ? new Number(subject.customClassesLessonsSingle[a]) : subject.single_lessons) 
          + 
          ((subject.customClassesLessonsDouble[a] ? new Number(subject.customClassesLessonsDouble[a]) : subject.double_lessons) * 2),
          done: 0
        };
        g.originalItems.forEach(function(c){
          if(c.subject_id == subject._id && c.classroom_id == a){
            x.done = x.done + 1;
          }
        })
        arr.push(x)
      })
      g.teacherDetails2 = arr;
    },
    editItem(day, lesson){
      var g = this;
      $.post(api + '/user/tables/edit-item', {
          jwt: g.user.jwt,
          day: day,
          lesson: lesson,
          table_id: g.table._id,
          teacher_id: g.currentItem.split(",")[0],
          subject_id: g.currentItem.split(",")[1],
          classroom_id: g.selected_classroom,
          checks: g.checks
      }).then(function(r){
        g.edits = {};
        g.getTable(false)
            g.gett()
        if(r.status == 200){
          alert(r.response, 200)
        }
      })
    },
    classroomTeachers(id){
      var g = this;
      var arr2 = [];
      var arr = [];
      g.items.forEach(function(a){
        if(!arr2.includes(a.teacher_id + ',' + a.subject_id)){
          arr2.push(a.teacher_id + ',' + a.subject_id)
          if(g.subjectName(a.subject_id) && g.teacherName(a.teacher_id)){
            arr.push({
              _id: a.teacher_id + ',' + a.subject_id,
              title: g.subjectName(a.subject_id) + ' ~ ' + g.teacherName(a.teacher_id)
            })
          }
        }
      })
      return arr;
    },
    refresh(){
      this.items = JSON.parse(JSON.stringify(this.items))
    },
    print(){
      if(this.noSelect){
        return alert("لم يتم اختيار فصل", 200)
      }
      var g = this;
      var win = window.open()
      win.document.write(`
      <html dir='rtl'>
        <head>
          <style>
            @page{
              margin: 0px
            }
            table, td, th {
              border: 1px solid;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }
            td{
              text-align: center
            }
            thead th{
              background: #FFF6DA !important
            }
          </style>
        </head>
        <body>
          ${$("#table").html()}
        </body>
      </html>
      `)
      win.document.close()
      win.print()
      win.close()
    },
    shuffleNow(){
      var g = this;
      g.logs = []
      g.shuffle.loading = true;
      $.post(api + '/user/tables/shuffle-arr', {
          jwt: g.user.jwt,
          id: g.id,
          teachers: JSON.stringify(g.shuffle.teachers),
          subjects: JSON.stringify(g.shuffle.subjects),
          classrooms: JSON.stringify(g.shuffle.classrooms)
      }).then(function(r){
          if(r.status != 100){
              g.shuffle.loading = false;
              alert(r.response, 200)
          }else{
            var scheduleResult = generateSchoolTimetable(r.response);
            g.logs = scheduleResult.logs;
            $.post(api + "/user/tables/shuffle", {
                jwt: g.user.jwt,
                arr: JSON.stringify(scheduleResult.timetable),
                id: g.id
            }).then(function(){
                g.getTable(false);
                g.gett();
                setTimeout(() => {
                g.shuffle.loading = false;
                  location.reload()
                }, 1000);
            }).fail(function(){
                g.shuffle.loading = false;
            })
          }
      }).fail(function(){
          g.shuffle.loading = false;
          alert('حدث خطأ في الاتصال', 200)
      })
    },
    getTable(nn=true){
      var g = this;
      g.loading = true;
      g.noSelect = true;
      $.post(api + '/user/tables/table', {
          jwt: g.user.jwt,
          id: g.id
      }).then(function(r){
          g.loading = false;
          if(r.status != 100){
              alert(r.response, 200)
          }else{
              g.table = r.response
              g.originalItems = r.response.items;
              if(!nn){
                g.viewClassroom(g.selected_classroom)
              }
          }
      }).fail(function(){
          g.loading = false;
          alert('حدث خطأ في الاتصال', 200)
      })
    },
    viewClassroom(id){
      this.noSelect = false;
      this.selected_classroom = id;
      this.items = this.originalItems.filter(function(x){
        if(x.classroom_id == id){
          return x;
        }
        return false;
      })
    },
    getItem(day, index){
      var x = {}, g = this;
      g.items.forEach(function(a){
        if(a.day == day && index == a.lesson){
          x = a;
        }
      })
      return x;
    },
    teacherName(id){
      var g = this;
      if(g.teachersObj[id]){
        return g.teachersObj[id].name;
      }
      return ""
    },
    subjectName(id){
      var g = this;
      if(g.subjectsObj[id]){
        return g.subjectsObj[id].title;
      }
      return ""
    },
    className(id){
      var g = this;
      if(g.classroomsObj[id]){
        return ' ~ ' + g.classroomsObj[id].title;
      }
      return ""
    },
    gett(){
      var g = this;
      $.post(api + '/user/classrooms/list', {
          jwt: g.user.jwt,
          id: g.id
      }).then(function(r){
          if(r.status != 100){
              alert(r.response, 200)
          }else{
              g.classrooms = r.response
              g.shuffle.classrooms = r.response.map(function(x){return x._id})
              g.classrooms.forEach(function(a){
                g.classroomsObj[a._id] = a;
              })
          }
      }).fail(function(){
          alert('حدث خطأ في الاتصال', 200)
      })
      $.post(api + '/user/subjects/list-s', {
          jwt: g.user.jwt,
          id: g.id,
          table_id: g.id
      }).then(function(r){
          if(r.status != 100){
              alert(r.response, 200)
          }else{
              g.subjects = r.response
              g.shuffle.subjects = r.response.map(function(x){return x._id})
              g.subjects.forEach(function(a){
                g.subjectsObj[a._id] = a;
              })
          }
      }).fail(function(){
          alert('حدث خطأ في الاتصال', 200)
      })
    }
  },
  created(){
    var g = this;
    g.getTable()
    $.post(api + '/user/teachers/list-s', {
        jwt: g.user.jwt,
        id: g.id,
        table_id: g.id
    }).then(function(r){
        if(r.status != 100){
            alert(r.response, 200)
        }else{
            g.teachers = r.response
            g.shuffle.teachers = r.response.map(function(x){return x._id})
            g.teachers.forEach(function(a){
              g.teachersObj[a._id] = a;
            })
        }
    }).fail(function(){
        alert('حدث خطأ في الاتصال', 200)
    })
    g.gett()
  }
}
</script>

<style>
.adsd:hover{
  background: #D1F8EF !important;
  cursor: pointer;
}
</style>